import {customerAddressFormStyles} from "@insite/content-library/Components/CustomerAddressForm"
import { css } from "styled-components";

customerAddressFormStyles.cancelButton= {
    mergeCss: true,
    color: "secondary",
    css: css`
        margin-right: 10px;
    `,
}